import { AnimatePresence } from "framer-motion";
import React, { useMemo } from "react";

import {
	BettoGameGridCardMotion,
	BettoGameGridMotion,
	BettoGameGridPlaceholderCard,
	CARD_VARIANT,
	getGridComponentForVariant,
	gridContainerVariants,
	gridItemVariants,
} from "./elements";
import { useBettoPlaceholderCount } from "./useBettoPlaceholderCount.js";

const PlaceholderGrid = ({ cardVariant, GridComponent }) => {
	const placeholderCount = useBettoPlaceholderCount(cardVariant);

	return (
		<BettoGameGridMotion
			key="betto-game-grid-loading"
			variants={gridContainerVariants}
			initial="hidden"
			animate="visible"
			exit="exit">
			<GridComponent className="search-game-container">
				{Array.from({ length: placeholderCount }, (_, index) => (
					<BettoGameGridPlaceholderCard
						key={`betto-game-placeholder-${index}`}
						$variant={cardVariant}
						aria-hidden="true"
					/>
				))}
			</GridComponent>
		</BettoGameGridMotion>
	);
};

export const BettoGameGridTransition = ({
	isLoading,
	games,
	transitionKey,
	renderGame,
	cardVariant = CARD_VARIANT.GRID,
	GridComponent,
	emptyState = null,
	disableAnimation = false,
}) => {
	const gridKey = transitionKey ?? "default";
	const hasGames = games?.length > 0;
	const ResolvedGrid = useMemo(
		() => GridComponent ?? getGridComponentForVariant(cardVariant),
		[GridComponent, cardVariant]
	);

	return (
		<AnimatePresence
			mode="wait"
			initial={!disableAnimation}>
			{isLoading ? (
				<PlaceholderGrid
					key="betto-game-grid-loading"
					cardVariant={cardVariant}
					GridComponent={ResolvedGrid}
				/>
			) : hasGames ? (
				disableAnimation ? (
					<ResolvedGrid
						key={`betto-game-grid-${gridKey}`}
						className="search-game-container">
						{games.map((game, index) => (
							<div key={game.id ?? game.game_id ?? `${gridKey}-${index}`}>
								{renderGame(game, index)}
							</div>
						))}
					</ResolvedGrid>
				) : (
					<BettoGameGridMotion
						key={`betto-game-grid-${gridKey}`}
						variants={gridContainerVariants}
						initial="hidden"
						animate="visible"
						exit="exit">
						<ResolvedGrid className="search-game-container">
							{games.map((game, index) => (
								<BettoGameGridCardMotion
									key={game.id ?? game.game_id ?? `${gridKey}-${index}`}
									variants={gridItemVariants}>
									{renderGame(game, index)}
								</BettoGameGridCardMotion>
							))}
						</ResolvedGrid>
					</BettoGameGridMotion>
				)
			) : (
				emptyState
			)}
		</AnimatePresence>
	);
};
